import { sendGAEvent } from '@noths/polaris-client-google-analytics';

import { ABOUT_THE_PRODUCT_HEADING } from 'src/components/layouts/PDP/copy';

export const trackProductInformationToggle = (expanded: boolean) => {
  sendGAEvent({
    event: 'custom_event',
    event_category: ABOUT_THE_PRODUCT_HEADING,
    event_action: expanded ? 'Expand' : 'Collapse',
    event_label: 'not set',
  });
};
